import { PileId, PileType } from 'src/games/phasersolitaire/logic/logic-types';
import { PileViewModel } from './pile-view-model';
import { GameServices } from '../../game-services';
import { CardViewModel } from '../card/card-view-model';

export class TableauPileViewModel extends PileViewModel {
  public readonly pileId: PileId;
  public readonly index: number;

  constructor(gameServices: GameServices, pileId: PileId, index: number) {
    super(gameServices, PileType.Tableau);
    this.pileId = pileId;
    this.index = index;
  }

  public droppedOver(draggingViewModel: CardViewModel) {
    draggingViewModel.droppedOntoPile(this.pileId);
  }
}
